export default __webpack_public_path__ + "static/media/get_ftn_arrow_right.09363180.svg";